import axios from 'axios';
import { WebResponse } from '../models/WebResponse';
import jsFileDownload from 'js-file-download';

export class AppDataService {
  static async Login(payload) {
    try {
      const axiosConfig = {
        url: 'users/login',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(response.data, response.data?.errorMessage || "Unable to log in. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async Logout() {
    try {
      const axiosConfig = {
        url: 'users/logout',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(null, null, null, response.status, response.headers);
      else return new WebResponse(null, "Unable to log out. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async RegisterUser(payload) {
    try {
      const axiosConfig = {
        url: `users`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async UpdateUser(payload) {
    try {
      const axiosConfig = {
        url: 'users',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "PUT",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async UploadProfileImage(payload) {
    try {
      const axiosConfig = {
        url: 'users/profile/image',
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept": "application/json"
        },
        method: "POST",
        data: payload,
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "Error uploading profile image. Supported file types are: JPG / JPEG, PNG", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async SubmitUserContainerRegistrationFile(payload) {
    try {
      const axiosConfig = {
        url: `registrations/UploadRegistration`,
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept": "application/json"
        },
        method: "POST",
        data: payload,
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else {
        return new WebResponse(response.data, "Error uploading registration file.", null, response.status, response.headers);
      } 
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async SendResetPasswordRequest(payload) {
    try {
      const axiosConfig = {
        url: 'users/forgot-password',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(response.data, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async ValidateResetPasswordToken(payload) {
    try {
      const axiosConfig = {
        url: 'users/forgot-password/validate-token',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        data: payload,  // { token: <string> }
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(response.data, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async ResetPassword(payload) {
    try {
      const axiosConfig = {
        url: 'users/reset-password',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        data: payload, // { userId: [int], newPassword: [string], confirmNewPassword: [string] }
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(response.data, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async SubmitUserContainerRegistration(payload) {
    try {
      const axiosConfig = {
        url: `registrations/UploadUPC/Multiple`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unkown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async UpdateUserContainerRegistration(payload) {
    try {
      const axiosConfig = {
        url: `registrations/EditUPC`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "POST",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async DeactivateUserContainerRegistration(payload) {
    try {
      const axiosConfig = {
        url: `registrations/DeleteUPC`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "DELETE",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }
  
  static async GetUserContainerRegistrations() {
    try {
      const axiosConfig = {
        url: `registrations/GetRegistrations`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "GET",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminDownloadUserRegistrations(userId) {
    try {
      const axiosConfig = {
        url: `registrations/DownloadUserRegistration/${userId}`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        method: "GET",
        responseType: 'blob',
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) {
        jsFileDownload(response.data, 'Registrations.xlsx');
        return new WebResponse(response.data, null, null, response.status, response.headers);
      } 
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminReviewContainerRegistration(payload) {
    try {
      const axiosConfig = {
        url: `registrations/Review`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "PUT",
        withCredentials: true,
        credentials: 'include',
        data: payload,
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unkown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminDownloadRecentRegistrations(startDt, endDt) {
    try {
      const axiosConfig = {
        url: `registrations/DownloadRecentRegistrations?startDate=${startDt}&endDate=${endDt}`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        method: "GET",
        responseType: 'blob',
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) {
        jsFileDownload(response.data, 'Registrations.xlsx');
        return new WebResponse(response.data, null, null, response.status, response.headers);
      } 
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async DownloadUserRegistrations() {
    try {
      const axiosConfig = {
        url: `registrations/DownloadUserRegistration`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        method: "GET",
        responseType: 'blob',
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) {
        jsFileDownload(response.data, 'OBRC Container Registry.xlsx');
        return new WebResponse(response.data, null, null, response.status, response.headers);
      } 
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async DownloadUserList() {
    try {
      const axiosConfig = {
        url: `users/DownloadUserList`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        method: "GET",
        responseType: 'blob',
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) {
        jsFileDownload(response.data, 'OBRC_Container_Registry_User_List.xlsx');
        return new WebResponse(response.data, null, null, response.status, response.headers);
      } 
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminGetRecentUserContainerRegistrations(startDate, endDate) {
    try {
      const axiosConfig = {
        url: `registrations/GetRegistrations/Recent?startDate=${startDate}&endDate=${endDate}`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "GET",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminGetUserContainerRegistrations(userId) {
    try {
      const axiosConfig = {
        url: `registrations/GetRegistrations/${userId}`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "GET",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminGetUsers() {
    try {
      const axiosConfig = {
        url: `users`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "GET",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }

  static async AdminGetUser(id) {
    try {
      const axiosConfig = {
        url: `users/${id}`,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        method: "GET",
        withCredentials: true,
        credentials: 'include',
        validateStatus: () => true
      };
  
      const response = await axios(axiosConfig);

      if(response.status < 400) return new WebResponse(response.data, null, null, response.status, response.headers);
      else return new WebResponse(null, "An unknown error occurred. Please try again later.", null, response.status, response.headers);
    }
    catch(ex) {
      console.error(ex.message);

      return new WebResponse(null, ex.message, ex.stackTrace, null, null);
    }
  }
}